
import React, { Component } from 'react';
import QuantityAdjust from './QuantityAdjust';
import { CollapseWhenOtherExpandType } from './../MenuItemModal';
import Variation, { VariationSelectionType, VariationType } from '../../../Model/Variation';

class MenuItemOptions extends React.Component {
    constructor(props) {
        super(props);
        this.hrefTarget = this.props.collapsible ? "variation-collapse-" + (this.props.classNameCollapsible || this.props.className) : ""
        this.state = {
            collapse: !this.isTruthy(this.props.defaultExpanded) || !!this.props.forceExpand,
        };
    }
    componentWillReceiveProps(nextProps) {
        let defaultExpanded = !this.isTruthy(nextProps.defaultExpanded)
        if (this.state.collapse !== defaultExpanded) {
            this.setState({
                collapse: !this.isTruthy(nextProps.defaultExpanded)
            })
        }
    }
    /**
     * When one of the item in the same group were to be expanded,
     * we can decide whether to auto collapse other item in the same group.
     * Useful when we have multiple side dish group and we want to collapse
     * all other side dish group for user to focus on ONE side dish group only
     */
    handleCollapseWhenOtherExpand = (e) => {
        let isNeedCollapse = false

        if (this.props.collapseWhenOtherExpand == CollapseWhenOtherExpandType.never) {
            isNeedCollapse = false
        }
        else if (this.props.collapseWhenOtherExpand == CollapseWhenOtherExpandType.sameGroup) {
            // Only collapse when other item in same group is expanding
            if (e.target['dataset'] && e.target['dataset'].collapsibleGroup == this.props.className) {
                isNeedCollapse = true
            }
        }
        else if (this.props.collapseWhenOtherExpand == CollapseWhenOtherExpandType.all) {
            // Collapse when any item is expanding
            isNeedCollapse = true
        }

        if (isNeedCollapse) {
            // Collapse this item when other item in same group is expanded

            // Only collapse "other" item, do not collapse the item that actually
            // is expanding now and triggered this event
            if (this.hrefTarget != e.target.id) {
                $('#'+this.hrefTarget).collapse('hide')
            }
        }
    }
    componentWillUnmount() {
        $(document).off('show.bs.collapse', this.handleCollapseWhenOtherExpand)
    }
    componentDidMount() {
        // Add event listener to collapse this item
        // when other item is expanding
        if (this.props.collapseWhenOtherExpand) {
            $(document).on('show.bs.collapse', this.handleCollapseWhenOtherExpand)
        }
        this.handleSelectChoice()
    }
    isTruthy(val) {
        return !(typeof val === 'undefined' || val == null || val === false || val === "false" || val === 0 || val === "0" || val === "")
    }
    componentDidUpdate = (prevProps, prevState) => {
        // forceExpand is a random numeric value, when parent changes this value,
        // we shall expand this item
        if (this.props.forceExpand && prevProps.forceExpand != this.props.forceExpand) {
            $('#'+this.hrefTarget).collapse('show')
        }
        if (prevProps.variations !== this.props.variations) {
            this.handleSelectChoice()
        }
    }

    getVariationByIdAndType = (id, type) => {
        if (this.props.variations) {
            const variation = this.props.variations.find((item) => item.id == id)
            if (type && variation) {
                if (variation.type != type) {
                    return null
                }
            }
            return variation
        }
        this.props.selected_variations && this.props.selected_variations.length
    }

    handleSelectChoice = () => {
        if (!this.props.onSideDishChange && this.props.className == "choices") {
            if (this.props.variations) {
                // Check the selected choice whether is valid (in stock)
                let selectedChoice = null
                if (this.props.selected_variations && this.props.selected_variations.length) {
                    selectedChoice = this.getVariationByIdAndType(this.props.selected_variations[0].id, VariationType.CHOICE)
                }

                // Not valid choice, select the first valid choice (in stock)
                if (!selectedChoice || !selectedChoice.in_stock) {
                    let count = this.props.variations.length
                    for (let i = 0; i < count; i++) {
                        const variationOrChoice = this.props.variations[i]
                        if (variationOrChoice.in_stock && variationOrChoice.type == VariationType.CHOICE) {
                            this.props.onSelected(variationOrChoice)
                            break
                        }
                    }
                }
            }
        }
    }
    render() {
        let className = "menu-option-title"
        if (this.props.collapsible) {
            className += ` collapsible`
            className += this.state.collapse ? " collapsed" : ""
        }
        return (
            <div className={'clearfix menu-item-modal-container'}>
                <div>
                    <a
                        className={className}
                        data-toggle="collapse"
                        data-target={'#'+this.hrefTarget}>
                        {this.props.title}
                    </a>
                    <div className={this.props.className + " " + (this.props.collapsibleClassName || "menu-item-option-collapsible-container") }>
                        {
                            this.props.body != null ?
                                (<div id={this.hrefTarget} className={"list-group" + (this.props.collapsible ? ` collapse ${this.state.collapse ? "" : "in"} ` : "")}>{this.props.body}</div>) :
                                this.getVariationListing()
                        }
                    </div>
                </div>
            </div>
        )
    }
    getTotalSideDishSelected = (orderQuantity) => {
        return this.props.variations.reduce((totalSelected, option) => {
            return totalSelected + (orderQuantity[option.id] || 0)
        }, 0)
    }
    handleOrderQuantityChanged = (sideDishOrVariation, add) => {
        if (this.props.isSideDish && this.props.onSideDishChange) {
            this.props.onSideDishChange(sideDishOrVariation, add)
        }
        else if (!this.props.isSideDish && this.props.onVariationQuantityChange) {
            this.props.onVariationQuantityChange(sideDishOrVariation, add)
        }
    }
    getVariationListing() {
        const isDineIn = !this.props.isPickupOrDelivery
        const { isSideDish, sideDishOverMaxQuantity, variationOverMaxQuantity, } = this.props
        const getPrice = (option) => {
            if (isDineIn || isSideDish) {
                return option.price
            }
            else {
                // Pickup and delivery will use different pricing
                return option.price_delivery != null ? option.price_delivery : option.price
            }
        }

        let getPriceString = (price) => {
            let value = Math.abs((price * 1)).toFixed(2)
            let sign = price > 0 ? (this.props.showPositiveSign && "+ ") : "- "
            return <span className="badge">{sign}{this.props.feePrefix} {value}</span>
        }

        let li = this.props.variations.map((option, i) => {
            let selected = (this.props.selected_variations || []).find(item => item.id == option.id && option.in_stock) != null
            let selectedSideDish = this.props.isSideDish && this.props.selectedSideDishes.find(sd => sd.variation_id == option.id)
            if (this.props.isSideDish && selectedSideDish) {
                selected = selectedSideDish.quantity > 0
            }
            let selectedVariation = !this.props.isSideDish && this.props.selectedVariations.find(sd => sd.variation_id == option.id)
            let sideDishPrice = ""
            if (this.props.isSideDish && (option.price && option.price != 0) ) {
                sideDishPrice = <span className="ml-2">{getPriceString(getPrice(option))}</span>
            }
            let overMaxQuantityStr = ""
            if ((sideDishOverMaxQuantity || []).indexOf(option.id) !== -1) {
                overMaxQuantityStr = `${lang.max}: ${option.max_quantity}`
            }
            else if ((variationOverMaxQuantity || []).indexOf(option.id) !== -1) {
                overMaxQuantityStr = `${lang.max}: ${option.max}`
            }

            const maxQuantityError = overMaxQuantityStr && <span className="text-danger" style={{fontWeight: "bold"}}>
                {overMaxQuantityStr}
            </span>

            const defaultSelectionType = Variation.getDefaultSelectionType(option)
            const isAdjustQuantity = (option.selection_type || defaultSelectionType) == VariationSelectionType.QUANTITY

            let liOnClicked = () => {!isAdjustQuantity && option.in_stock && !this.props.onSideDishChange && this.props.onSelected(option) }
            if (option.type == VariationType.SIDE_DISH && !isAdjustQuantity && option.in_stock && this.props.onSelected) {
                liOnClicked = () => this.props.onSelected(option)
            }
            return <li key={option.id} data-id={option.id} className={`list-group-item` + (this.props.highlightSelected && selected ? ' active' : '')}  onClick={liOnClicked} style={{ opacity: option.in_stock ? "" : "0.6", width: "100%", display: "inline-block" }}>
                <div style={{display: "flex"}}>
                    <span style={{ paddingLeft: '6px', flex: "1 0 100px" }}>
                        {option.name}{sideDishPrice}
                        {
                            option.type != VariationType.CHOICE &&
                            this.props.withFee && <span className="ml-2">{getPriceString(getPrice(option))}</span>
                        }
                    </span>

                    {
                        option.type == VariationType.CHOICE ?
                        this.props.withFee && getPriceString(getPrice(option)) :
                        <span style={{flex: "0 0 90px"}}>
                            {
                                isSideDish &&
                                (
                                    isAdjustQuantity ?
                                    <div style={{display: "inline-block", float: "right", textAlign: "right"}}>
                                        <QuantityAdjust
                                            className={this.props.className}
                                            ordering={this.state.ordering}
                                            buttonEnabled={option.in_stock != null ? !option.in_stock : true}
                                            order_quantity={selectedSideDish && selectedSideDish.quantity || 0}
                                            menuItem={this.props.menuItem}
                                            handleOrderQuantityChanged={(add) => this.handleOrderQuantityChanged(option, add)}
                                        />
                                        {maxQuantityError}
                                    </div> :
                                    <div style={{display: "inline-block", float: "right", textAlign: "right"}}>
                                        {
                                            selected ? <i className="fas fa-check-square" style={{ color: 'green', fontSize: '14px' }}></i> : <i className="fas fa-square" ></i>
                                        }
                                    </div>
                                )
                            }
                            {
                                !isSideDish &&
                                (
                                    isAdjustQuantity ?
                                    <div style={{display: "inline-block", float: "right", textAlign: "right"}}>
                                        <QuantityAdjust
                                            numberStyle={{fontWeight: "bold"}}
                                            className={this.props.className}
                                            ordering={this.state.ordering}
                                            buttonEnabled={option.in_stock != null ? !option.in_stock : true}
                                            order_quantity={selectedVariation && selectedVariation.quantity || 0}
                                            menuItem={this.props.menuItem}
                                            handleOrderQuantityChanged={(add) => this.handleOrderQuantityChanged(option, add)}
                                        />
                                        {maxQuantityError}
                                    </div> :
                                    (
                                        // Handle Option
                                        !this.props.highlightSelected &&
                                        <div style={{display: "inline-block", float: "right", textAlign: "right"}}>
                                            {
                                                selected ? <i className="fas fa-check-square" style={{ color: 'green', fontSize: '14px' }}></i> : <i className="fas fa-square" ></i>
                                            }
                                        </div>
                                    )
                                )
                            }
                        </span>
                    }
                </div>
            </li>
        })

        return <div id={this.hrefTarget}
            className={`menu-item-option-collapsible ${this.props.collapsible ? ` collapse ${this.state.collapse ? "" : "in"}` : ""}`}
            data-collapsible-group={this.props.className}>
            {
                this.props.hint
            }
            <ul className={"list-group"} style={{ height: "auto" }}>
                {li}
            </ul>
        </div>
    }

    pinModal() {
        $('#table-pin-modal').modal();
        $('#pin-input').val('');
        $('#random-number').text(Util.getRandomNumber())
        let me = this
        $(function () {
            $('#table-pin-modal')
                .off('hidden.bs.modal')
                .on('hidden.bs.modal', function () {
                    // By default, when this modal is dismissed (aborted),
                    // remove the loading indicator on the MenuItemModal so
                    // that user can attempt to add item to cart again.
                    //
                    // But if user successfully entered/setup PIN,
                    // 'Confirm' button onClick will remove this listener so
                    // that loading indicator will persist while
                    // 'me.pickItem()' is running background tasks
                    me.setState({ ordering: false })
                })

            $("#modal-two-confirm-table-pin-modal").off('click').on('click', function () {
                $('#table-pin-modal').off('hidden.bs.modal')
                let pin = $('#txtPin').val();
                if (pin == null || pin == '') { // Use random pin
                    pin = Util.getRandomNumber();
                }//use their own pin
                me.createTableSession(pin).then(function () {
                    me.pickItem()
                })
            })
        });
    }
}
MenuItemOptions.defaultProps = {
    withFee: false,
    feePrefix: "RM",
    highlightSelected: false,
    body: null,
    collapsible: true,
    showPositiveSign: false,
    defaultExpanded: true,
    maxSideDishQuantity: 0,
}

export default MenuItemOptions;